import {
  toastQueue,
  type ToastContent as QueueToastContent,
} from '../components/ui/overlays/toast-queue';

export type ToastContent = QueueToastContent;

export interface ToastOptions {
  timeout?: number;
  onClose?: () => void;
  action?: {
    label: string;
    onPress: () => void;
  };
}

/**
 * Hook that provides access to toast notifications
 * @returns Methods to display different types of toast notifications
 */
export function useToast() {
  return {
    success: (title: string, description?: string, options?: ToastOptions) => {
      displayToast(
        {
          title,
          description,
          variant: 'success',
          action: options?.action,
        },
        options,
      );
    },

    error: (title: string, description?: string, options?: ToastOptions) => {
      displayToast(
        {
          title,
          description,
          variant: 'error',
          action: options?.action,
        },
        options,
      );
    },

    info: (title: string, description?: string, options?: ToastOptions) => {
      displayToast(
        {
          title,
          description,
          variant: 'info',
          action: options?.action,
        },
        options,
      );
    },

    warning: (title: string, description?: string, options?: ToastOptions) => {
      displayToast(
        {
          title,
          description,
          variant: 'warning',
          action: options?.action,
        },
        options,
      );
    },

    toast: (content: ToastContent, options?: ToastOptions) => {
      displayToast(content, options);
    },
  };
}

// Helper function to display toast with React Aria ToastQueue
function displayToast(content: ToastContent, options?: ToastOptions) {
  toastQueue.add(content, {
    timeout: options?.timeout ?? 5000,
    onClose: options?.onClose,
  });
}
